<template>
  <div>
    <registrations-cards :account-data="accountData"></registrations-cards>
  </div>
</template>
<script>
  import Vue from 'vue'
  import RegistrationsCards from '@/components/Dashboard/Views/Components/RegistrationsCards.vue'
  export default{
    components: {
      RegistrationsCards
    },
    props: ['accountData']
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Validations.vue